export enum QuestionsDataTest {
  TITLE = "QUESTIONS_TITLE",
  SUB_TITLE = "QUESTIONS_SUB_TITLE",
  ERROR = "QUESTIONS_ERROR",
  CONTINUE_BTN = "QUESTIONS_CONTINUE_BTN",
  BACK_BTN = "QUESTIONS_BACK_BTN",
  YES_BTN = "QUESTIONS_YES_BTN",
  NO_BTN = "QUESTIONS_NO_BTN",
  SKIP_BTN = "QUESTIONS_SKIP_BTN",
  CONFIRM_DETAILS_INPUT = "CONFIRM_DETAILS_INPUT",
  CHECKBOX_OPTIONS = "QUESTIONS_CHECKBOX_OPTIONS",
  ADDITIONAL_DETAIL_INPUT = "QUESTIONS_ADDITIONAL_DETAIL_INPUT",
  ADDITIONAL_DETAIL_ADD_BTN = "QUESTIONS_ADDITIONAL_DETAIL_ADD_BTN",
  ADDITIONAL_DETAIL_DELETE_BTN = "QUESTIONS_ADDITIONAL_DETAIL_DELETE_BTN",
  WHY_WE_WANT = "QUESTIONS_WHY_WE_WANT",
  WHY_WE_WANT_LINK = "QUESTIONS_WHY_WE_WANT_LINK",
  WHY_WE_WANT_INNER_HTML = "QUESTIONS_WHY_WE_WANT_INNER_HTML",

  // TEMPORARY NEEDS QUESTIONS //
  TEMPORARY_NEEDS_DATE_PICKER = "TEMPORARY_NEEDS_DATE_PICKER",
  TEMPORARY_NEEDS_REASON = "TEMPORARY_NEEDS_REASON",
  TEMPORARY_NEEDS_QUESTION = "TEMPORARY_NEEDS_QUESTION"
}